import { useMemo } from 'react'

import type { MassAdditionCreateForm } from '@/types/MassAddition'

import CardContent from "@components/card/CardContent";

import './styles/mass-addition-list-info.scss'

interface Props {
    list: any[],
    form: MassAdditionCreateForm
}

function MassAdditionListInfo({list, form}: Props) {
    const countItems = useMemo(() => {
        return list.length || 0
    }, [list])

    const countAdded = useMemo(() => {
        return list.filter((item) => item && item.is_added).length || 0
    }, [list])

    const voiceoverName = useMemo(() => {
        return form.voiceoverName || '-'
    }, [form])

    return (
        <div className={'mass-addition-accept'}>
            <CardContent isPaddingTop={true}>
                <div className={'mass-addition-accept__top'}>
                    <ul>
                        <li className={'app-list-option'}>
                            <span className={'app-list-option__name'}>Найдено</span>
                            <span className={'app-list-option__value'}>{countItems}</span>
                        </li>
                        {countAdded > 0 && (
                            <li className={'app-list-option'}>
                                <span className={'app-list-option__name'}>Уже добавлено</span>
                                <span className={'app-list-option__value'}>{countAdded}</span>
                            </li>
                        )}
                        <li className={'app-list-option'}>
                            <span className={'app-list-option__name'}>Озвучка</span>
                            <span className={'app-list-option__value'}>
                                { voiceoverName }
                            </span>
                        </li>
                    </ul>
                </div>
            </CardContent>
        </div>
    )
}

export default MassAdditionListInfo